import { render, staticRenderFns } from "./r-currency-correction-table.vue?vue&type=template&id=b799b146"
import script from "./r-currency-correction-table.vue?vue&type=script&lang=js"
export * from "./r-currency-correction-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b799b146')) {
      api.createRecord('b799b146', component.options)
    } else {
      api.reload('b799b146', component.options)
    }
    module.hot.accept("./r-currency-correction-table.vue?vue&type=template&id=b799b146", function () {
      api.rerender('b799b146', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/currency/r-currency-correction-table.vue"
export default component.exports